module.exports = __webpack_public_path__ + "img/jingdiangushi@3x.9a29cee2.png";